import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditInvoiceFollowupStatus extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "invoice_followup_status";
  }
}
